import React, { Component } from 'react';
import update from 'immutability-helper';
import { UpdateNationality, UpdatePreferredLanguage } from '../../../components';
import Portal from '../../Portal/Portal';
import TextField from '../../global/fields/TextField';

class NationalityAndLanguage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        fields: {
          nationality: {
            label: 'Nationality *',
            value: '',
            displayName: '',
            type: 'text',
            validateRule: 'text',
          },
          preferredLanguage: {
            label: 'Preferred Language *',
            value: '',
            displayName: '',
            type: 'text',
            validateRule: 'text',
          },
        },
      },
      showUpdatePreferredLanguage: false,
      showUpdateNationality: false,
    };
    this.updateFieldValue = this.updateFieldValue.bind(this);
  }

  updateFieldValue(fk, value, error, displayName) {
    this.setState((state) =>
      update(state, {
        form: {
          fields: {
            [fk]: {
              value: { $set: value },
              displayName: { $set: displayName },
              error: { $set: error },
            },
          },
        },
        showValidateBlock_email: { $set: false },
        showValidateBlock_password: { $set: false },
      }),
    );
  }

  togglePreferredLanguage = () => {
    this.setState({
      showUpdatePreferredLanguage: !this.state.showUpdatePreferredLanguage,
    });
  };

  toggleNationality = () => {
    this.setState({
      showUpdateNationality: !this.state.showUpdateNationality,
    });
  };

  _renderField(key, toggle) {
    const { type, placeholder, label, validateRule, value, displayName, error, helperText } =
      this.state.form.fields[key];

    return (
      <div onClick={toggle}>
        <TextField
          key={key}
          fk={key}
          type={type}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          value={displayName}
          validateRule={validateRule}
          validateObj={{ [validateRule]: value }}
          error={error}
          showError={this.state.form.validate}
          updateFieldData={(key) => {
            this.props.onChangeFieldValue(key, value);
          }}
          triggerOnChange={true}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this._renderField('nationality', () => this.toggleNationality())}
        {this._renderField('preferredLanguage', () => this.togglePreferredLanguage())}
        <p class="font-italic">
          The preferred language is to facilitate translation within the app.
        </p>

        <Portal
          hide={() => this.toggleNationality()}
          isOpen={this.state.showUpdateNationality}
          minWidth={710}
        >
          <UpdateNationality
            hide={() => this.toggleNationality()}
            value={this.state.form.fields.nationality.value}
            fk={'nationality'}
            updateFieldData={this.updateFieldValue}
          />
        </Portal>
        <Portal
          hide={() => this.togglePreferredLanguage(false)}
          isOpen={this.state.showUpdatePreferredLanguage}
          minWidth={710}
        >
          <UpdatePreferredLanguage
            hide={() => this.togglePreferredLanguage(false)}
            value={this.state.form.fields.preferredLanguage.value}
            fk={'preferredLanguage'}
            updateFieldData={this.updateFieldValue}
          />
        </Portal>
      </div>
    );
  }
}

export default NationalityAndLanguage;
